export default __webpack_public_path__ + "static/media/sunrise_filled.708ddd88.svg";